export default "/assets/images/filter-BS.1f7aa34d04602d8c.png";